import * as React from 'react';
import s from '../../RequestCall.scss';
import { useTranslation } from 'react-i18next';
import { FormInputProps } from './FormTypes';
import { FormContext } from './FormContext';
import { Cell, Input, Text } from '@wix/design-system';

export const FormInput: React.FC<FormInputProps> = ({
  name,
  label,
  labelSize = 'small',
  inputSize = 'small',
  isRequired = false,
}) => {
  const {
    values: formValues,
    handleChange,
    errors: validationErrors,
  } = React.useContext(FormContext);
  const { t } = useTranslation();
  return (
    <Cell span={6}>
      <>
        <div className={s.inputLabel}>
          <Text weight='normal' size={labelSize}>
            {t(label)}
            &nbsp;
            {isRequired && <span className={s.required}>*</span>}
          </Text>
        </div>
        <Input
          size={inputSize}
          name={name}
          value={formValues[name]}
          statusMessage={t(validationErrors[name])}
          placeholder={t(`${label}.placeholder`)}
          dataHook={name}
          status={validationErrors[name] ? Input.StatusError : undefined}
          onChange={handleChange}
        />
      </>
    </Cell>
  );
};
